type GeocoderResponse = Awaited<ReturnType<typeof import("@api-hono/routes/gmaps/mapsRoute.controller").handleGeocode>>['data'];
import { calculateDistance } from './calculateDistance';
import { KNOWN_ERROR } from '@lib/types/errors';

export const checkGeocodeDistance = (
    data: GeocoderResponse,
    deliveryAddress: { lat: number, lng: number },
    addressType: 'DELIVERY' | 'PICKUP',
) => {
    const firstResult = data.results[0]
    if (firstResult
        // && !firstResult.partial_match
    ) {
        const geocodedAddress = firstResult;
        const distance = calculateDistance(
            { lat: deliveryAddress.lat!, lng: deliveryAddress.lng! },
            { lat: Number(geocodedAddress.geometry.location.lat), lng: Number(geocodedAddress.geometry.location.lng) }
        );
        if (distance > 0.3) {
            throw new KNOWN_ERROR(`${addressType} address is too far from geocoded address`, `${addressType}_ADDRESS_TOO_FAR_FROM_GEOCODED_ADDRESS`);
        }
    } else {
        throw new KNOWN_ERROR(`${addressType} address is invalid`, `${addressType}_ADDRESS_INVALID`);
    }
}

/**
const mapResult = await geocode(getAddress(deliveryAddress), deliveryAddress?.country ?? '');
checkGeocodeDistance(mapResult.data as any, {
    lat: deliveryAddress?.lat!,
    lng: deliveryAddress?.lng!
});
 */
export const getAddress = (deliveryAddress: any, includeCountry: boolean = false) => {
    const addressFields = [
        'address1',
        'address2',
        'city',
        'state',
        'postalCode'
        // 'country', country already used in the geocoding request
    ]
    if (includeCountry) {
        addressFields.push('country');
    }
    const address = addressFields.map(field => deliveryAddress?.[field])
        .filter(value => value !== null && value !== undefined && value !== '').join(' ')
    return address;
}